var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// BluePrint JS
import { Popover as BPPopover } from '@blueprintjs/core';
import classNames from 'classnames';
// constants
import { prefix } from '../../constants';
export const Popover = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(BPPopover, Object.assign({ modifiers: { arrow: { enabled: false } }, className: classNames(`${prefix}-popover`) }, props), children));
};
//# sourceMappingURL=Popover.js.map